<!--调光弹窗-->
<template>
	<div class="dimmingDialog">
		<el-dialog title="调光设置" :visible.sync="dialogFormVisible">
			<el-form :model="form">
				<el-form-item label="光照" :label-width="formLabelWidth">
					<el-input v-model="form.illumination" autocomplete="off" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="绝对调光" :label-width="formLabelWidth">
					<el-input v-model="form.dimming" autocomplete="off" :disabled="dimmingShow"></el-input>
				</el-form-item>
				<el-form-item label="相对调光" :label-width="formLabelWidth">
					<el-slider v-model="form.dimmingValue" :step="5" :show-tooltip="false" :max='max' show-stops :disabled="!dimmingShow"></el-slider>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="config">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				dialogFormVisible: false,
				formLabelWidth: '120px',
				form: {
					illumination: '',
					dimming: 0,
					dimmingValue: 35,
				},
				variable: '', //变量
				variableValue: '', //变量的值
				dimmingShow: true, //相对调光或者绝对调光
				max: 70,
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
		},
		watch: {
			variable(nv, ov) {
				this.form={
					illumination: '',
					dimming: 0,
					dimmingValue: 35,
				}
			},
			dialogFormVisible(nv, ov) {
				this.form={
					illumination: '',
					dimming: 0,
					dimmingValue: 35,
				}
				if(nv)
				this.$api.realApi.getMACRealValueWithID(this.variableValue, '', respon => {
					if(!isempty(respon)) {
						this.form.illumination = respon.data.split(':')[0] + ".00%"
					}
				})
			}
		},
		methods: {
			config() {
				let value=0
				var reg = new RegExp("^(\\d|[1-9]\\d|100)$");
				if(!reg.test(this.form.dimming)){
					this.$message.warning("请输入0带100数值")
					return
				}
				this.dimmingShow?value=this.form.dimmingValue / 5 + 1:value=this.form.dimming
				this.$api.lightOldApi.lightSinglewrite(this.variable, this.variableValue,value, respon => {
					this.$message({
						message:respon,
						type: 'success'
					});
					this.dialogFormVisible = false
				})
			},
		}
	}
</script>

<style>
	.dimmingDialog .el-dialog {
		width: 30%;
	}
</style>